var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BigTitle',{attrs:{"bigtitle":_vm.bigtitle}}),_c('div',{staticClass:"siteInformation"},_vm._l((_vm.userList),function(item,index){return _c('div',{key:index,staticClass:"siteInforInner"},[_vm._v("\n      "+_vm._s(item.key+':'+item.value)+"\n    ")])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }